module.exports = __webpack_public_path__ + "img/vertical_3_6_7042.11ff9cc3.png";